import { selector } from 'lib/selectors';

const ui = (state) => state.ui;

const modalSelector = selector(ui, (x) => x.modal);
const approvalFlowSelector = selector(ui, (x) => x.approvalFlow);
const workspaceSelector = selector(ui, (x) => x.workspace);
const selectSelector = selector(ui, (x) => x.select);
const drawerSelector = selector(ui, (x) => x.drawer);

export const isOpenModalDocumentHotkeysSelector = selector(modalSelector, (modal) => modal.isOpenDocumentHotkeysModal);

export const isOpenModalWorkspaceHotkeysSelector = selector(
  modalSelector,
  (modal) => modal.isOpenWorkspaceHotkeysModal,
);

export const isOpenAFPanelSelector = selector(approvalFlowSelector, (af) => af.isOpen);

export const getUiAFlStampModeSelector = selector(approvalFlowSelector, (af) => af.stampMode);

export const getUiAFlStampSelector = selector(approvalFlowSelector, (af) => af.stamp);

export const getUiWorkspaceIsActiveContextMenuSelector = selector(workspaceSelector, (ws) => ws.isActiveContextMenu);

export const isUiSelectOpenSelector = selector(selectSelector, (s) => s.isOpen);

export const isOpenUiDrawerSelector = selector(drawerSelector, (d) => d.isOpen);
